import React, { useEffect, useState } from 'react';

import { fetchSinToken } from "../../helpers/fetch";


import 'animate.css';
import { Form, Schema, Button, Alert } from 'rsuite';
import { TextField } from '../../helpers/FormControlRSuit';

const model = Schema.Model({
    email: Schema.Types.StringType().isEmail('Porfavor ingresa un email valido.')
});

export const RecuperarForm = ({viewForm}) => {
    
    const [formError, setFormError] = useState({});
    const [form, setform] = useState({});
    const [formValue, setFormValue] = useState({
        email: ''
    });
    const [loading, setLoading] = useState(false)

    
    const handleSubmit = async() => {
        if (form.check()) { 
            setLoading(true);
            const resp = await fetchSinToken('passwordrecovery', formValue, 'POST', 'json');
            const body = await resp.json();
            if(!body.ok){
                console.error(body);
                if(body.messages) Alert.error(JSON.stringify(body.messages).replace(/{|}|"/g, ''), 5000);
                else Alert.error(body.message, 5000);
            } else{
              Alert.success(`Correo enviado.`, 5000);
            }
            setTimeout(() => {
              setLoading(false);
            }, 1000);
        }
    }
   

    return (
        <Form
                fluid
                ref={ref => (setform(ref))}
                onChange={formValue => {
                  setFormValue(formValue);
                }}
                onCheck={formError => {
                  setFormError(formError);
                }}
                formValue={formValue}
            name="loginForm"
            className="animate__animated animate__fadeIn" 
            onSubmit={handleSubmit}
            noValidate
            model={model}
        >
            <div className="text-center m-auto">
                <p className="text-muted mb-4 mt-3">
                    Ingrese tu dirección de correo electrónico y te enviaremos un mail con instrucciones para restablecer su contraseña.
                </p>
                <h5 className="auth-title mb-4">Recuperar contraseña</h5>
            </div>
            <div className="form-group">
                <TextField
                    autoFocus={ true }
                    className="form-control"
                    disabled={ false }
                    label="Correo electronico"
                    name="email"
                    // accepter={MaskedInputPhone}
                    required
                />
            </div>
            <Button
              appearance="primary"
              className="btn btn-primary btn-block btn-submit"
              loading={loading}
              type="submit"
            >
              Recuperar Contraseña
            </Button>
            <div className="auth-options">
                <a href="/" className="forgot-link" onClick={viewForm} >Regresar a Login</a>
            </div>
        </Form>
    )
}
